import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import URLSearchParams from 'url-search-params';
import * as appActions from './actions/app';
import App from './containers/App';
import configureStore from './stores/chat';
import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

const store = configureStore();

const expectedUrlParams = ['name', 'lastName', 'email'];

ReactDOM.render(
  <AppContainer>
    <Provider store={store}>
      <App bindToWindowOnResize />
    </Provider>
  </AppContainer>,
  document.getElementById('app'),
  () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    let clientData;
    store.dispatch(appActions.checkScheduleMessage());
    store.dispatch(appActions.checkSchedule());

    if (token) {
      clientData = token;
    } else if (expectedUrlParams.every(p => params.get(p))) {
      clientData = {};
      expectedUrlParams.forEach(p => clientData[p] = params.get(p));
    }

    if (clientData) {
      store.dispatch(appActions.startChat(
        new Date().getTimezoneOffset(),
        clientData,
        true
      ));
    }
  }
);

if (module.hot) {
  module.hot.accept('./containers/App', () => {
    const NextApp = require('./containers/App').default; // eslint-disable-line global-require

    ReactDOM.render(
      <AppContainer>
        <Provider store={store}>
          <NextApp bindToWindowOnResize />
        </Provider>
      </AppContainer>,
      document.getElementById('app')
    );
  });
}



// WEBPACK FOOTER //
// ./client.js